var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemplateGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.519,
    height: 13.949,
    viewBox: "0 0 10.519 13.949",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#707070;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-width:0.8px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-527.6 -215.6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(528 216)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9,38v3.144L12.144,38Z",
    transform: "translate(-2.425 -27.995)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15.575,16.149H9V3h9.719V13Z",
    transform: "translate(-9 -3)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 6,
    transform: "translate(2 2.501)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 6,
    transform: "translate(2 5.501)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 6,
    transform: "translate(2 8.501)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplateGray);
export default __webpack_public_path__ + "static/media/template-gray.1b8beb5f0655983fe3a752be0b723bf2.svg";
export { ForwardRef as ReactComponent };